import axios from "axios"
import { BUZON_EMPRESAS_PRODUCT } from "common/constants"
import * as ROUTES from "routes/RoutePaths"
import { empresaActivaStore } from "utils/local-storage-key-store"

export default class UserService {
  getUserByToken() {
    return axios.get("/Usuario/by-current-user")
  }

  setEmpresaActiva(idEmpresa: $TSMigrationFixMe) {
    empresaActivaStore.set(idEmpresa)
    return axios.put(`/Usuario/empresa/${idEmpresa}/activa`)
  }

  changeProfile({ firstName, lastName, personaId }: $TSMigrationFixMe) {
    return axios.put(
      `/Persona/${personaId}`,
      {
        nombre: firstName,
        apellidos: lastName,
      },
      {
        baseURL: import.meta?.env?.REACT_APP_API_URL,
      }
    )
  }

  loginUsuarioExterno({
    cif,
    email,
    identityId,
    razonSocial,
  }: $TSMigrationFixMe) {
    return axios.post("/Usuario/insert-user-from-api", {
      cif,
      email,
      identityId,
      razonSocial,
    })
  }

  login({
    email,
    password,
    product = BUZON_EMPRESAS_PRODUCT,
  }: $TSMigrationFixMe) {
    return axios.post(
      "/Authentication/Log-in",
      { email, password, product },
      { baseURL: import.meta.env.REACT_APP_API_AUTH }
    )
  }

  loginInternoUser({
    email,
    password,
    product = BUZON_EMPRESAS_PRODUCT,
  }: $TSMigrationFixMe) {
    return axios.post(
      "/Authentication/Log-in-ad",
      { username: email, password, product },
      { baseURL: import.meta.env.REACT_APP_API_AUTH }
    )
  }

  refreshTokens({
    token,
    refreshToken,
    product = BUZON_EMPRESAS_PRODUCT,
  }: $TSMigrationFixMe) {
    return axios.post(
      "/Authentication/Refresh-token",
      {
        accessToken: token,
        refreshToken,
        product,
      },
      {
        baseURL: import.meta.env.REACT_APP_API_AUTH,
      }
    )
  }

  sendResetPasswordToEmail(email: $TSMigrationFixMe) {
    return axios.post(
      `/Authentication/Send-reset-password-email`,
      {
        email,
        passwordResetUrl: `${window.location.origin}${ROUTES.RECOVERY_PASSWORD_STEP_2}`,
      },
      {
        baseURL: import.meta.env.REACT_APP_API_AUTH,
      }
    )
  }

  resetPassword({ password, token, userId }: $TSMigrationFixMe) {
    return axios.post(
      `/Authentication/Reset-password`,
      {
        password,
        token,
        userId,
      },
      {
        baseURL: import.meta.env.REACT_APP_API_AUTH,
      }
    )
  }

  sendUserInvitation(emails: $TSMigrationFixMe) {
    return axios.post("/Usuario/invitar-usuario?aceptaPolitica=true", emails)
  }

  getEmpresaActivaCuentasBancarias() {
    return axios.get("/Usuario/empresa-activa/cuentas-bancarias")
  }

  getUserCesionActive() {
    return axios.get(
      "/Usuario/empresa-activa/any-cesiones-o-verificaciones-facturas-pendientes"
    )
  }
}
